export default __webpack_public_path__ + "static/image-24-073a3a93e093287ef86ab5cfa1b2ae88.jpg";